export const mockOrders = [
  {
    id: "ORD-2026-001",
    productId: "1",
    productTitle: "Premium Wireless Earbuds Pro X200",
    productImage: "https://public.readdy.ai/ai/img_res/21255a2c1532bd7ae16d4cc60225bf53.jpg",
    buyer: "Marcus Johnson",
    buyerEmail: "marcus.j@email.com",
    buyerPhone: "+1 (555) 234-5678",
    quantity: 2,
    total: 99.98,
    status: "pending",
    trackingNumber: "",
    carrier: "",
    orderDate: "2026-04-10",
    address: "123 Oak Street, Austin, TX 78701",
    referredBy: "Jessica Martinez",
    referralPlatform: "tiktok",
  },
  {
    id: "ORD-2026-002",
    productId: "4",
    productTitle: "Vitamin C Brightening Serum 30ml",
    productImage: "https://readdy.ai/api/search-image?query=vitamin%20C%20brightening%20serum%20glass%20bottle%20skincare%20product%20clean%20white%20background%20minimalist%20photography&width=400&height=400&seq=prod4&orientation=squarish",
    buyer: "Aisha Williams",
    buyerEmail: "aisha.w@email.com",
    buyerPhone: "+1 (555) 876-4321",
    quantity: 3,
    total: 59.97,
    status: "shipped",
    trackingNumber: "1Z999AA10123456784",
    carrier: "UPS",
    orderDate: "2026-04-08",
    address: "456 Maple Ave, Chicago, IL 60601",
    referredBy: "Sarah Chen",
    referralPlatform: "youtube",
  },
  {
    id: "ORD-2026-003",
    productId: "6",
    productTitle: "Portable Bluetooth Speaker IPX7",
    productImage: "https://readdy.ai/api/search-image?query=portable%20bluetooth%20speaker%20cylindrical%20black%20waterproof%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod6&orientation=squarish",
    buyer: "Carlos Rivera",
    buyerEmail: "carlos.r@email.com",
    buyerPhone: "+1 (555) 345-9012",
    quantity: 1,
    total: 39.99,
    status: "delivered",
    trackingNumber: "9400111899223397623910",
    carrier: "USPS",
    orderDate: "2026-04-05",
    address: "789 Pine Blvd, Miami, FL 33101",
    referredBy: "",
    referralPlatform: "",
  },
  {
    id: "ORD-2026-004",
    productId: "2",
    productTitle: "Organic Cotton Oversized Hoodie",
    productImage: "https://readdy.ai/api/search-image?query=organic%20cotton%20oversized%20hoodie%20beige%20cream%20color%20folded%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod2&orientation=squarish",
    buyer: "Lily Thompson",
    buyerEmail: "lily.t@email.com",
    buyerPhone: "+1 (555) 567-8901",
    quantity: 2,
    total: 69.98,
    status: "processing",
    trackingNumber: "",
    carrier: "",
    orderDate: "2026-04-11",
    address: "321 Elm Street, Seattle, WA 98101",
    referredBy: "DeShawn Williams",
    referralPlatform: "tiktok",
  },
  {
    id: "ORD-2026-005",
    productId: "8",
    productTitle: "Resistance Bands Set 5-Level",
    productImage: "https://readdy.ai/api/search-image?query=resistance%20bands%20set%20colorful%20five%20levels%20fitness%20exercise%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod8&orientation=squarish",
    buyer: "James Park",
    buyerEmail: "james.p@email.com",
    buyerPhone: "+1 (555) 678-2345",
    quantity: 4,
    total: 67.96,
    status: "pending",
    trackingNumber: "",
    carrier: "",
    orderDate: "2026-04-12",
    address: "654 Cedar Lane, Denver, CO 80201",
    referredBy: "Tyler Brooks",
    referralPlatform: "twitter",
  },
  {
    id: "ORD-2026-006",
    productId: "3",
    productTitle: "Smart LED Desk Lamp with USB-C",
    productImage: "https://readdy.ai/api/search-image?query=modern%20smart%20LED%20desk%20lamp%20white%20minimalist%20design%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=prod3&orientation=squarish",
    buyer: "Nina Patel",
    buyerEmail: "nina.p@email.com",
    buyerPhone: "+1 (555) 789-3456",
    quantity: 1,
    total: 28.99,
    status: "shipped",
    trackingNumber: "1FedEx9023456781",
    carrier: "FedEx",
    orderDate: "2026-04-09",
    address: "987 Birch Road, Boston, MA 02101",
    referredBy: "",
    referralPlatform: "",
  },
];

export const mockReviews = [
  {
    id: "r1",
    productId: "1",
    user: "Marcus J.",
    avatar: "https://readdy.ai/api/search-image?query=young%20black%20man%20portrait%20casual%20smile%20natural%20light%20headshot&width=60&height=60&seq=rev1&orientation=squarish",
    rating: 5,
    title: "Absolutely love these earbuds!",
    body: "Sound quality is incredible for the price. The noise cancellation works great on my commute. Battery lasts all day easily. Highly recommend to anyone looking for premium audio without breaking the bank.",
    date: "2026-04-01",
    verified: true,
    helpful: 42,
    images: ["https://readdy.ai/api/search-image?query=wireless%20earbuds%20unboxing%20lifestyle%20photo%20person%20wearing%20earbuds%20casual&width=200&height=200&seq=revimg1&orientation=squarish"],
    referredBy: "Jessica Martinez",
  },
  {
    id: "r2",
    productId: "1",
    user: "Priya S.",
    avatar: "https://readdy.ai/api/search-image?query=indian%20woman%20portrait%20professional%20headshot%20warm%20smile%20office%20background&width=60&height=60&seq=rev2&orientation=squarish",
    rating: 5,
    title: "Best purchase this year",
    body: "I was skeptical at first but these earbuds blew me away. The fit is perfect, they stay in during workouts, and the call quality is crystal clear. My coworkers can hear me perfectly on calls.",
    date: "2026-03-28",
    verified: true,
    helpful: 31,
    images: [],
    referredBy: "",
  },
  {
    id: "r3",
    productId: "1",
    user: "Tyler B.",
    avatar: "https://readdy.ai/api/search-image?query=athletic%20man%20portrait%20gym%20background%20confident%20smile%20casual&width=60&height=60&seq=rev3&orientation=squarish",
    rating: 4,
    title: "Great value, minor fit issue",
    body: "Sound is excellent and the case charges fast. Only minor complaint is the right earbud feels slightly loose after long runs. But for the price, this is unbeatable. Would still buy again.",
    date: "2026-03-20",
    verified: true,
    helpful: 18,
    images: [],
    referredBy: "Tyler Brooks",
  },
  {
    id: "r4",
    productId: "1",
    user: "Emma R.",
    avatar: "https://readdy.ai/api/search-image?query=latina%20woman%20portrait%20bright%20smile%20natural%20light%20casual%20headshot&width=60&height=60&seq=rev4&orientation=squarish",
    rating: 5,
    title: "Saw this on TikTok and had to get it",
    body: "Jessica Martinez's review convinced me and I'm so glad it did! These are genuinely amazing. The touch controls are intuitive and the sound profile is perfect for pop and R&B. Fast shipping too!",
    date: "2026-03-15",
    verified: true,
    helpful: 27,
    images: ["https://readdy.ai/api/search-image?query=woman%20wearing%20wireless%20earbuds%20selfie%20casual%20home%20background%20happy&width=200&height=200&seq=revimg2&orientation=squarish"],
    referredBy: "Jessica Martinez",
  },
];

export const mockProductSpecs = {
  "1": {
    highlights: [
      "Active Noise Cancellation (ANC) with 3 adjustable levels",
      "30-hour total battery life (8hr earbuds + 22hr case)",
      "Bluetooth 5.3 with multipoint connection (2 devices)",
      "IPX5 water resistance — sweat & rain proof",
      "10mm dynamic drivers with Hi-Res Audio certification",
      "Wireless charging case (Qi compatible)",
    ],
    specs: [
      { label: "Driver Size", value: "10mm Dynamic" },
      { label: "Frequency Response", value: "20Hz - 20kHz" },
      { label: "Bluetooth Version", value: "5.3" },
      { label: "Range", value: "Up to 33ft (10m)" },
      { label: "Battery (Earbuds)", value: "8 hours (ANC on)" },
      { label: "Battery (Case)", value: "22 hours additional" },
      { label: "Charging Time", value: "1.5 hours (case), 15min = 2hrs" },
      { label: "Water Resistance", value: "IPX5" },
      { label: "Weight", value: "5.4g per earbud" },
      { label: "Colors", value: "Pearl White, Midnight Black, Sage Green" },
      { label: "Warranty", value: "12 months manufacturer" },
      { label: "In the Box", value: "Earbuds, Charging Case, USB-C Cable, 3 Ear Tip Sizes" },
    ],
  },
};
